import { createOrganizer } from "api/company.api";
import OrganizerForm from "components/company/OrganizerForm";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function CreateOrganizer() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState("");

  const handleSubmit = async (data) => {
  try {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (key === "projectModules") {
        value.forEach((module) => formData.append("projectModules[]", module));
      } else if (key === "companyLogo" && value instanceof File) {
        formData.append("companyLogo", value);
      } else if (value !== null && value !== "") {
        formData.append(key, value);
      }
    });

    await createOrganizer(formData);
    navigate("/admin/companies");
  } catch (err) {
    console.error(
      "API ERROR:",
      err.response?.data || err.message
    );
     setAlert(
    err.response?.data?.message ||
    "Something went wrong. Try again."
  );
  }
};

  return (
    <OrganizerForm  
      onSubmit={handleSubmit}
      submitLabel="Create Organizer"    
      alert={alert}
      setAlert={setAlert}
      onBack={() => navigate(-1)}   
    />
  );
}
